<template>
  <div class="form">
    <div class="delete" v-if="canDelete" @click="confirm()"></div>

    <b-form-row>
      <b-col cols="12">
        <input-component
          name="fullname"
          label="Nome completo"
          :required="true"
          v-model="fullname"
          maxlength="255"
        />
      </b-col>
    </b-form-row>

    <b-form-row>
      <b-col cols="12" md="6">
        <input-component
          name="role"
          label="Cargo"
          :required="true"
          class="mb-0"
          v-model="role"
          maxlength="255"
        />
      </b-col>

      <b-col cols="12" md="6">
        <select-component
          name="country"
          label="País"
          :required="true"
          :options="countries"
          ref="country"
          v-model="country"
        />
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

import InputComponent from "@/components/Form/Inputs/InputComponent";
import SelectComponent from "@/components/Form/Inputs/SelectComponent";

import countries from "@/static/pep-countries";

export default {
  name: "PoliticalFormComponent",
  props: ["formKey", "canDelete", "formaux"],
  components: {
    InputComponent,
    SelectComponent,
  },
  mounted() {
    if (this.$store.state.form.ownersAndContacts.political[this.formKey].fullname) {
      this.$v.$touch();
    }
    
    this.$refs.country.value = 'Brasil';
  },
  methods: {
    confirm() {
      this.$store.commit("setConfirmForm", { form: "political", key: this.formKey });
      this.$bvModal.show("modal-confirm");
    },
  },
  computed: {
    fullname: {
      get() {
        return this.$store.state.form.ownersAndContacts.political[
          this.formKey
        ].fullname;
      },
      set(value) {
        this.$store.commit("setContactData", {
          form: "political",
          key: "fullname",
          index: this.formKey,
          value,
        });
      },
    },
    role: {
      get() {
        return this.$store.state.form.ownersAndContacts.political[
          this.formKey
        ].role;
      },
      set(value) {
        this.$store.commit("setContactData", {
          form: "political",
          key: "role",
          index: this.formKey,
          value,
        });
      },
    },
    country: {
      get() {
        return this.$store.state.form.ownersAndContacts.political[
          this.formKey
        ].country;
      },
      set(value) {
        this.$store.commit("setContactData", {
          form: "political",
          key: "country",
          index: this.formKey,
          value,
        });
      },
    },
    countries: () => countries,
  },
  validations: {
    fullname: {
      required,
    },
    role: {
      required,
    },
    country: {
      required,
    },
  },
};
</script>

<style lang="scss">
.form {
  border-radius: 8px;
  border: 2px solid #e7e7e7;
  padding: 40px 40px 15px 40px;
  margin: 20px 0;
  position: relative;
}

.delete {
  content: " ";
  top: -10px;
  right: -10px;
  width: 25px;
  z-index: 99;
  height: 25px;
  position: absolute;
  border-radius: 50%;
  background-color: #ed5417;
  cursor: pointer;
}

.delete::after {
  content: "−";
  color: white;
  position: absolute;
  font-weight: bold;
  margin-left: 0.45rem;
  margin-top: 0.1rem;
}
</style>
